import { Examples } from '@/types';

export const ExampleMStoreDeleteConfirmationRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
        {
          ...Examples.ExampleMStoreDeleteConfirmation,
          components: {
            default: () =>
              import(
                /* webpackChunkName: "ExampleMStoreDeleteConfirmation" */
                '@/views/examples/ExampleMStoreDeleteConfirmation.vue'
              )
          }
        }
      ]
    : [];
